const DEFAULT_TIMEOUT_MS = 5000;

const normalizeBaseUrl = (value) => String(value || '').trim().replace(/\/+$/, '');
const resolveApiV2BaseUrl = () => {
  const explicit = normalizeBaseUrl(process.env.API_V2_URL);
  if (explicit) return explicit;

  const apiUrl = normalizeBaseUrl(process.env.API_URL);
  if (!apiUrl) return '/api/v2';

  if (/\/api\/v1$/i.test(apiUrl)) {
    return apiUrl.replace(/\/api\/v1$/i, '/api/v2');
  }

  if (/\/api\/v2$/i.test(apiUrl)) {
    return apiUrl;
  }

  return `${apiUrl}/api/v2`;
};

const parseTimeoutMs = (value) => {
  const parsed = Number.parseInt(String(value || ''), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_TIMEOUT_MS;
};

export const getPortalEventsConfig = () => ({
  baseUrl: normalizeBaseUrl(
    process.env.PORTAL_EVENTS_API_BASE_URL || `${resolveApiV2BaseUrl()}/portal-events`
  ),
  timeoutMs: parseTimeoutMs(process.env.PORTAL_EVENTS_API_TIMEOUT_MS),
});

export const requirePortalEventsConfig = () => {
  const config = getPortalEventsConfig();
  if (!config.baseUrl) {
    throw new Error('PORTAL_EVENTS_API_BASE_URL is required for portal event persistence.');
  }
  return config;
};
